import { template as template_9b492d9dbda541039477c1534d3a3964 } from "@ember/template-compiler";
import { decOpacityToHex } from 'eflex/util/opacity-helper';
import { isBlank } from '@ember/utils';
import OpacityInput from 'eflex/components/inputs/opacity';
import { inputVal } from 'eflex/helpers';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
const DEFAULT_OPACITY = '100';
const DEFAULT_COLOR = '#000000';
const updateColor = (onUpdateColor, opacity, color)=>{
    color ??= DEFAULT_COLOR;
    const opacityHex = decOpacityToHex(opacity);
    onUpdateColor(color, opacity, color.concat(opacityHex));
};
const updateOpacity = (onUpdateColor, color, opacity)=>{
    opacity ??= DEFAULT_OPACITY;
    const opacityHex = decOpacityToHex(opacity);
    onUpdateColor(color, opacity, color.concat(opacityHex));
};
export default template_9b492d9dbda541039477c1534d3a3964(`
<div class="component-inputs-color-opacity input-group flex-nowrap" ...attributes>
  {{#let
    (if (isBlank @selectedOpacity) DEFAULT_OPACITY @selectedOpacity)
    (if (isBlank @selectedColor) DEFAULT_COLOR @selectedColor)
  as |opacity color|}}
    <input
      type="color"
      value={{color}}
      disabled={{@disabled}}
      class="square-color-picker {{if @isStroke "square-color-picker-stroke"}} {{if @hideOpacity "w-100"}}"
      {{on "input" (inputVal (fn updateColor @updateColor opacity))}}
    />
    {{#unless @hideOpacity}}
      <div class="flex-fill border-start border-gray-200">
        <OpacityInput
          class="rounded-start-0 border-start-0 shadow-none w-100"
          @opacity={{opacity}}
          @disabled={{@disabled}}
          @update={{fn updateOpacity @updateColor color}}
        />
      </div>
    {{/unless}}
  {{/let}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
